import { memo } from 'react';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import { UIBurgerSubMenuShell } from '@headless-workspace/core-ui';
import { GlowMenuButton, PropsWithDataLayer } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';
import { CategoryValue } from '../../../../server';
import { MenuSubCategoriesListItems } from '../MenuSubCategoriesListItems';

type BurgerSubMenuProps = {
    href: string;
    title: string;
    subCategories: CategoryValue[];
    className?: string;
} & PropsWithDataLayer;

export const BurgerSubMenu: ComponentMemo<BurgerSubMenuProps> = memo(
    ({ href, title, subCategories, dataLayer, className }) => {
        const t = useTranslations('Header.burgerMenu');

        return (
            <UIBurgerSubMenuShell title={title} goBackAriaLabel={t('ariaLabel.goBack')}>
                <ul className={'flex flex-col gap-0.25'}>
                    <li>
                        <GlowMenuButton
                            className={clsx('bg-surface-primary', className)}
                            key={'all'}
                            label={t('label.seeAll')}
                            href={href}
                            dataLayer={dataLayer}
                            titleReferent={title} // This prop is used for SEO purposes
                        />
                    </li>
                    <MenuSubCategoriesListItems
                        categoryDataLayerId={dataLayer?.id}
                        categories={subCategories}
                        isDesktop={false}
                    />
                </ul>
            </UIBurgerSubMenuShell>
        );
    },
);

BurgerSubMenu.displayName = 'BurgerSubMenu';
